import { ChangeEvent, useRef } from "react";

interface OTPProps {
	length: number;
	formData: string[];
}

export const OTPInput = ({ formData, length }: OTPProps) => {
	return (
		<div className="grid grid-cols-4 gap-3">
			{Array.from({ length }, (_, index) => (
				<input
					key={index}
					type="text"
					maxLength={1}
					disabled
					value={formData[index] || ""}
					className={
						"border border-[#A0A0A0] text-black w-12 h-14 focus:border-2 text-center outline-none rounded focus:border-black"
					}
					style={{ marginRight: index === length - 1 ? "0" : "10px" }}
				/>
			))}
		</div>
	);
};
